document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.formulation-tabs-section .tab-button');
  const tabContents = document.querySelectorAll('.formulation-tabs-section .tab-content');
  const selectSelected = document.querySelector('.formulation-tabs-section .select-selected');
  const selectItems = document.querySelector('.formulation-tabs-section .select-items');
  
  console.log('Tabs initialized:', tabButtons.length, 'buttons,', tabContents.length, 'content sections');
  
  // Desktop tab button functionality
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.dataset.tab;
      const tabColor = button.dataset.color;
      switchToTab(tabId, tabColor);
      
      // Sync mobile dropdown
      if (selectSelected) {
        selectSelected.textContent = button.textContent.trim();
        selectSelected.dataset.tab = tabId;
        selectSelected.dataset.color = tabColor;
      }
    });
  });
  
  // Custom dropdown functionality
  if (selectSelected && selectItems) {
    // Toggle dropdown on click
    selectSelected.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      selectItems.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
    
    // Handle option selection
    const selectOptions = selectItems.querySelectorAll('div');
    selectOptions.forEach(option => {
      option.addEventListener('click', function() {
        const tabId = this.dataset.tab;
        const tabColor = this.dataset.color;
        const tabText = this.textContent;
        
        // Update selected display
        selectSelected.textContent = tabText;
        selectSelected.dataset.tab = tabId;
        selectSelected.dataset.color = tabColor;
        
        // Switch tab
        switchToTab(tabId, tabColor);
        
        // Close dropdown
        selectItems.classList.add('select-hide');
        selectSelected.classList.remove('select-arrow-active');
        
        // Smooth scroll to content on mobile
        const activeTab = document.getElementById(tabId);
        if (activeTab) {
          setTimeout(() => {
            activeTab.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start' 
            });
          }, 100);
        }
        
        // Analytics tracking for mobile dropdown
        if (typeof gtag !== 'undefined') {
          gtag('event', 'mobile_dropdown_change', {
            'event_category': 'formulation_tabs',
            'event_label': tabText,
            'value': tabId
          });
        }
      });
    });
  }
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function() {
    closeAllSelect();
  });
  
  // Initialize first tab
  if (tabButtons.length > 0) {
    const firstTabId = tabButtons[0].dataset.tab;
    const firstTab = document.getElementById(firstTabId);
    if (firstTab) {
      firstTab.style.display = 'block';
    }
  }
  
  /**
   * Close all select dropdowns except the current one
   * @param {HTMLElement} elmnt - The current select element to keep open
   */
  function closeAllSelect(elmnt) {
    const selectItems = document.querySelectorAll('.select-items');
    const selectSelected = document.querySelectorAll('.select-selected');
    
    selectItems.forEach(item => {
      if (elmnt !== item.previousElementSibling) {
        item.classList.add('select-hide');
      }
    });
    
    selectSelected.forEach(selected => {
      if (elmnt !== selected) {
        selected.classList.remove('select-arrow-active');
      }
    });
  }
  
  /**
   * Switch to a specific tab
   * @param {string} tabId - The ID of the tab to switch to
   * @param {string} tabColor - The color of the tab
   */
  function switchToTab(tabId, tabColor) {
    const activeTab = document.getElementById(tabId);
    
    console.log('Tab switched:', tabId, 'Color:', tabColor);
    
    if (!activeTab) {
      console.error('Tab content not found:', tabId);
      return;
    }
    
    // Update desktop tab buttons
    tabButtons.forEach(btn => btn.classList.remove('active'));
    const activeButton = document.querySelector(`[data-tab="${tabId}"]`);
    if (activeButton) {
      activeButton.classList.add('active');
    }
    
    // Update tab underlines
    const allUnderlines = document.querySelectorAll('.tab-underline');
    allUnderlines.forEach(underline => {
      underline.style.backgroundColor = '#E6E6E6';
    });
    if (activeButton) {
      const underline = activeButton.querySelector('.tab-underline');
      if (underline) {
        underline.style.backgroundColor = tabColor;
      }
    }
    
    // Switch tab content with fade animation
    tabContents.forEach(content => {
      content.classList.remove('active');
      content.style.display = 'none';
      content.style.opacity = '0';
    });
    
    activeTab.style.display = 'block';
    setTimeout(() => {
      activeTab.classList.add('active');
      activeTab.style.opacity = '1';
    }, 50);
    
    // Update pill container colors and animations
    const pillContainer = activeTab.querySelector('.pill-container');
    const pill = activeTab.querySelector('.pill');
    // const circleColor = activeTab.dataset.circleColor;
    const pillColor = activeTab.dataset.pillColor;
    
    if (pillContainer && pill) {
      // pillContainer.style.backgroundColor = circleColor;
      pill.style.backgroundColor = pillColor;
      
      animateElement(pillContainer);
      animateElement(pill);
    }
  }
  
  /**
   * Add a simple animation to an element
   * @param {HTMLElement} element - The element to animate
   */
  function animateElement(element) {
    element.style.transition = 'transform 0.3s ease, background-color 0.5s ease';
    element.style.transform = 'scale(1.05)';
    
    setTimeout(() => {
      element.style.transform = 'scale(1)';
    }, 300);
  }
});
